import BaseController from "../sharedControllers/BaseController";
import JSONModel from "sap/ui/model/json/JSONModel";
import { Routes } from "akademika/akamont/constants/Routes";
import { GenericTile$PressEvent } from "sap/m/GenericTile";
import { TileData } from "../../models/TileData";
import {
  AllDashboardTiles,
  FilterTiles,
} from "akademika/akamont/utils/DashboardTileUtil";
import { URLHelper } from "sap/m/library";

/**
 * @namespace akademika.akamont.pages.dashboard
 */
export default class Dashboard extends BaseController {
  route = Routes.DASHBOARD;

  private defaultTiles: TileData[] = [
    AllDashboardTiles.UserList,
    AllDashboardTiles.Partners,
    AllDashboardTiles.EditPriceList,
    AllDashboardTiles.PriceListOverview,
    AllDashboardTiles.WorkOrderList,
    AllDashboardTiles.SpecificationList,
  ];

  public async onRouteMatched() {
    const isUserAuthenticated =
      await this.getOwnerComponent().checkUserAuthenticationSynchronized();

    if (!isUserAuthenticated) {
      this.navTo(Routes.LOGIN);
      throw "User is unauthenticated";
    }

    let filteredTiles = FilterTiles(this.defaultTiles);

    this.getView()?.setModel(
      new JSONModel({
        dashboardItems: filteredTiles,
      })
    );
  }

  public tilePress(e: GenericTile$PressEvent) {
    const tileData = e
      .getSource()
      .getBindingContext()
      ?.getProperty("") as TileData;

    this.navTo(tileData.target, tileData.targetParams);
  }

  public onWebsiteLinkPress() {
    URLHelper.redirect("https://www.akademika.si/", true);
  }
}
